import React from "react";
import {Box, Tab, Tabs} from "@mui/material";
import {multipliersMenu} from "../constant/multipliersMenu";

const MultipliersTabs = ({ selectedTab, handleTabChange }) => {
    return (
        <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
            <Tabs
                value={selectedTab}
                onChange={handleTabChange}
                variant="scrollable"
                scrollButtons="auto"
                sx={{
                    minHeight: 30,
                    maxHeight: 30,
                    borderBottom: "none",
                    "& .MuiTabs-indicator": {
                        display: "none"
                    },
                    justifyContent: "flex-end",
                    display: "flex"
                }}
            >
                {multipliersMenu.map(({ id, label }) => (
                    <Tab
                        key={id}
                        value={id}
                        label={label}
                        sx={{
                            textTransform: "none",
                            fontWeight: 500,
                            fontSize: "12px",
                            color: "#2A4A49 !important",
                            backgroundColor: selectedTab === id ? "#61D5A9" : "#F8F8F8",
                            borderRadius: "10px 10px 0 0",
                            marginRight: "4px",
                            maxHeight: 30,
                            minHeight: 30,
                            padding: "0 16px",
                            borderBottom: "none !important",
                            borderLeft: selectedTab === id ? "none" : "1px solid #D3D3D3",
                            borderTop: selectedTab === id ? "none" : "1px solid #D3D3D3",
                            borderRight: selectedTab === id ? "none" : "1px solid #D3D3D3",
                            "&:hover": {
                                backgroundColor: selectedTab === id ? "#61D5A9" : "#E0E0E0"
                            },
                            "&:last-of-type": {
                                marginRight: 0
                            }
                        }}
                    />
                ))}
            </Tabs>
        </Box>
    );
};

export default MultipliersTabs;
